import { render } from "./ViewsPrivacy.vue?vue&type=template&id=7d8c2840"
import script from "./ViewsPrivacy.vue?vue&type=script&lang=js"
export * from "./ViewsPrivacy.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__